module.exports = __webpack_public_path__ + "img/Photo18.77116145.jpg";